module.exports = __webpack_public_path__ + "media/PinkNoise.0000b5ed.wav";